import { useLoginStore } from '@/features/login/store';

let controller = new AbortController();

useLoginStore.subscribe((state, previous) => {
    if (previous.login && (!state.login || state.sessionId !== previous.sessionId)) {
        controller.abort(new DOMException('Sessão encerrada', 'AbortError'));
        controller = new AbortController();
    }
});

export function getUserSessionSignal(): AbortSignal {
    return controller.signal;
}
